module.exports = __webpack_public_path__ + "static/img/49651ff202fff3c020c30bde10100ac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_03.png
// module id = 9CeG
// module chunks = 1